import { jsx as _jsx } from "react/jsx-runtime";
import { SettingsPage } from 'z3k-settings/components/main-settings';
import { SharedAccessPage } from 'z3k-settings/components/shared-access';
import { ViewConfig } from 'z3k-settings/components/view-config';
import { WebElementComponent } from 'z3k-settings/components/web-elements/component';
import { UserRoleComponent } from 'z3k-settings/components/users/user-roles';
import { UserComponent } from 'z3k-settings/components/users/user';
import { UIGroupComponent } from 'z3k-settings/components/ui-groups/component';
import { WiredTemperatureSensorControl } from 'z3k-settings/components/temperature-sensors/wired-temperature-sensor';
import { AnalogSensorControl } from 'z3k-settings/components/temperature-sensors/analog-temperature-sensor';
import { AnalogInputComponent } from 'z3k-settings/components/analog-inputs/component';
import { GuardZoneComponent } from 'z3k-settings/components/guard-zones/guard-zone';
import { TMKeyControl } from 'z3k-settings/components/guard-zones/tm-key';
import { HeatingCircuitComponent } from 'z3k-settings/components/heating-circuits/heating-circuit';
import { BoilerCascadeComponent } from 'z3k-settings/components/heating-circuits/boiler-cascade';
import { BoilerGroupComponent } from 'z3k-settings/components/heating-circuits/boiler-group';
import { ScenarioComponent } from 'z3k-settings/components/scenarios/component';
import { NotificationControl } from 'z3k-settings/components/notifications/component';
import { OutputActionControl } from 'z3k-settings/components/output-actions/component';
import { IOExtensionControl } from 'z3k-settings/components/io-extensions/component';
import { Fob868 } from 'z3k-settings/components/radio/fobs/fob-868';
import { RadioSensorComponent } from 'z3k-settings/components/radio/radiosensors/868/components/component';
import { RadioModuleComponent } from 'z3k-settings/components/radio/radiomodules/components/component';
import { Fob433 } from 'z3k-settings/components/radio/fobs/fob-433';
import { RadioSensor433Component } from 'z3k-settings/components/radio/radiosensors/433/components/component';
import { ModBusDeviceComponent } from 'z3k-settings/components/modbus-devices/modbus-devices';
import { BoilerAdapterControl } from 'z3k-settings/components/managed-mechanisms/boiler-adapter';
import { RelayControlComponent } from 'z3k-settings/components/managed-mechanisms/relay-control';
import { PumpComponent } from 'z3k-settings/components/managed-mechanisms/pump';
import { ThreewayTapComponent } from 'z3k-settings/components/managed-mechanisms/threeway-tap';
import { BuzzerComponent } from 'z3k-settings/components/guard-zones/buzzer/buzzer';
import { AnalogOutputComponent } from 'z3k-settings/components/managed-mechanisms/analog-output';
import { OutputActionsList } from 'z3k-settings/components/output-actions';
import { RadioModulesList } from 'z3k-settings/components/radio/radiomodules';
import { ModBusDevicesList } from 'z3k-settings/components/modbus-devices';
import { RadioRelaysList } from 'z3k-settings/components/radio/radiorelay';
import { FobsList } from 'z3k-settings/components/radio/fobs';
import { UsersList } from 'z3k-settings/components/users';
import { NotificationsList } from 'z3k-settings/components/notifications';
import { TrustedNumbers } from 'z3k-settings/components/notifications/trusted_number';
import { TemperatureSensorsList } from 'z3k-settings/components/temperature-sensors';
import { AnalogInputsList } from 'z3k-settings/components/analog-inputs';
import { ModBusSettings } from 'z3k-settings/components/modbus-devices/settings';
import { ScenariosList } from 'z3k-settings/components/scenarios';
import { ManagedMechanismsList } from 'z3k-settings/components/managed-mechanisms';
import { HeatingCircuitsList } from 'z3k-settings/components/heating-circuits';
import { InterfaceSettingsComponent } from 'z3k-settings/components/heating-circuits/interface_settings';
import { HeatingModesList } from 'z3k-settings/components/heating-modes';
import { HeatingModeComponent } from 'z3k-settings/components/heating-modes/component';
import { WebElementsList } from 'z3k-settings/components/web-elements';
import { UIGroupList } from 'z3k-settings/components/ui-groups';
import { UISystemTabs } from 'z3k-settings/components/ui-groups/system_tabs';
import { ConfigCard } from 'z3k-settings/components/service/components/config-card';
import { DeviceMaintenance } from 'z3k-settings/components/service/device-maintenance';
import { ServicePage } from 'z3k-settings/components/service';
import { SearchPage } from 'z3k-settings/components/search';
import { RadioSensorsList } from 'z3k-settings/components/radio/radiosensors';
import { GuardZonesList } from 'z3k-settings/components/guard-zones';
import { GuardIndicators } from 'z3k-settings/components/guard-zones/guard-indicator';
import { GuardIndicatorComponent } from 'z3k-settings/components/guard-zones/guard-indicator/guard-indicator';
import { Buzzers } from 'z3k-settings/components/guard-zones/buzzer';
import { InterfaceSettings } from 'z3k-settings/components/interface-settings';
import { EditorInterval } from 'console/schedule-editor/editorIntreval';
import { Z3kSettingsDialog } from 'z3k-settings/dialog';
import { Z3kAdditionsRoutes, Z3kRoutes, Z3kSecondRoutes } from './type';
import { HistoryZ3KConfig } from 'z3k-settings/components/history-z3k-config';
import { MQTTTopicsList } from 'console/device-settings/z3k/components/mqtt-topics';
import { MQTTTopicsComponent } from 'z3k-settings/components/mqtt-topics/mqtt_component';
import { SettingsConnectionMQTT } from 'z3k-settings/components/mqtt-topics/settings_connection_mqtt';
import { ClimaticBoilers } from 'z3k-settings/climatic/boilers/boilers';
import { ClimaticConfiguration } from 'z3k-settings/climatic/configuration/configuration';
import { ClimaticDigitalSensors } from 'z3k-settings/climatic/digital-sensors/digital-sensors';
import { ClimaticNotifications } from 'z3k-settings/climatic/notifications/notifications';
import { ClimaticNtcSensors } from 'z3k-settings/climatic/ntc_sensors/ntc-sensors';
import { ClimaticHeatingCircuits } from 'z3k-settings/climatic/heating-circuits/heating-circuits';
import { ClimaticHeatingCircuitsItem } from 'z3k-settings/climatic/heating-circuits-item/heating-circuits-item';
const z3k_settings = [
    [
        Z3kRoutes.sensors,
        AnalogInputsList,
        [
            [Z3kSecondRoutes.analog_inputs, AnalogInputComponent],
            [Z3kSecondRoutes.radiosensor433, RadioSensor433Component],
            [Z3kSecondRoutes.radiosensor868, RadioSensorComponent],
        ],
    ],
    [
        Z3kRoutes.modbus_devices,
        ModBusDevicesList,
        [
            [Z3kSecondRoutes.modbus_devices, ModBusDeviceComponent],
            [Z3kSecondRoutes.port_rs485, ModBusSettings],
        ],
    ],
    [
        Z3kRoutes.mqtt_topics,
        MQTTTopicsList,
        [
            [Z3kSecondRoutes.mqtt_address, SettingsConnectionMQTT],
            [Z3kSecondRoutes.mqtt_topics, MQTTTopicsComponent],
        ],
    ],
    [
        Z3kRoutes.guard_zones,
        GuardZonesList,
        [
            [Z3kSecondRoutes.zone, GuardZoneComponent],
            [Z3kSecondRoutes.tm_keys, TMKeyControl],
        ],
    ],
    [
        Z3kRoutes.guard_indicators,
        GuardIndicators,
        [[Z3kSecondRoutes.indicator, GuardIndicatorComponent]],
    ],
    [Z3kRoutes.buzzers, Buzzers, [[Z3kSecondRoutes.buzzer, BuzzerComponent]]],
    [
        Z3kRoutes.heating_circuits,
        HeatingCircuitsList,
        [
            [Z3kSecondRoutes.heating_circuit, HeatingCircuitComponent],
            [Z3kSecondRoutes.boiler_groups, BoilerGroupComponent],
            [Z3kSecondRoutes.boiler_cascades, BoilerCascadeComponent],
        ],
    ],
    [
        Z3kRoutes.interface_settings,
        InterfaceSettings,
        [
            [Z3kSecondRoutes.heating_interface, InterfaceSettingsComponent],
            [Z3kSecondRoutes.ui_system_group, UISystemTabs],
        ],
    ],
    [
        Z3kRoutes.heating_modes,
        HeatingModesList,
        [
            [
                Z3kSecondRoutes.heating_modes,
                HeatingModeComponent,
                [Z3kAdditionsRoutes.intervalweek, EditorInterval],
            ],
            [
                Z3kSecondRoutes.boiler_modes,
                HeatingModeComponent,
                [Z3kAdditionsRoutes.intervalweek, EditorInterval],
            ],
        ],
    ],
    [
        Z3kRoutes.managed_mechanisms,
        ManagedMechanismsList,
        [
            [Z3kSecondRoutes.boiler_adapters, BoilerAdapterControl],
            [Z3kSecondRoutes.relay_controls, RelayControlComponent],
            [Z3kSecondRoutes.pumps, PumpComponent],
            [Z3kSecondRoutes.threeway_taps, ThreewayTapComponent],
            [Z3kSecondRoutes.analog_outputs, AnalogOutputComponent],
        ],
    ],
    [
        Z3kRoutes.notifications,
        NotificationsList,
        [
            [Z3kSecondRoutes.notifications, NotificationControl],
            [Z3kSecondRoutes.trusted_numbers, TrustedNumbers],
        ],
    ],
    [
        Z3kRoutes.output_actions,
        OutputActionsList,
        [[Z3kSecondRoutes.output_actions, OutputActionControl]],
    ],
    [
        Z3kRoutes.radiomodules,
        RadioModulesList,
        [[Z3kSecondRoutes.radiomodules, RadioModuleComponent]],
    ],
    [
        Z3kRoutes.radiorelays,
        RadioRelaysList,
        [[Z3kSecondRoutes.radiorelay, RadioSensorComponent]],
    ],
    [
        Z3kRoutes.radiosensors,
        RadioSensorsList,
        [
            [Z3kSecondRoutes.radiosensor433, RadioSensor433Component],
            [Z3kSecondRoutes.radiosensor868, RadioSensorComponent],
        ],
    ],
    [
        Z3kRoutes.fobs,
        FobsList,
        [
            [Z3kSecondRoutes.radiofobs, Fob868],
            [Z3kSecondRoutes.fob, Fob433],
        ],
    ],
    [
        Z3kRoutes.scenarios,
        ScenariosList,
        [[Z3kSecondRoutes.scenarios, ScenarioComponent]],
    ],
    [
        Z3kRoutes.users,
        UsersList,
        [
            [Z3kSecondRoutes.users, UserComponent],
            [Z3kSecondRoutes.user_roles, UserRoleComponent],
        ],
    ],
    [
        Z3kRoutes.temperature_sensors,
        TemperatureSensorsList,
        [
            [Z3kSecondRoutes.wired_temperature_sensors, WiredTemperatureSensorControl],
            [Z3kSecondRoutes.analog_temperature_sensors, AnalogSensorControl],
            [Z3kSecondRoutes.radiosensor868, RadioSensorComponent],
        ],
    ],
    [
        Z3kRoutes.web_elements,
        WebElementsList,
        [[Z3kSecondRoutes.web_elements, WebElementComponent]],
    ],
    [Z3kRoutes.ui, UIGroupList, [[Z3kSecondRoutes.ui_groups, UIGroupComponent]]],
    [
        Z3kRoutes.service,
        ServicePage,
        [
            [Z3kSecondRoutes.configuration, ConfigCard],
            [Z3kSecondRoutes.device_maintenance, DeviceMaintenance],
            [Z3kSecondRoutes.io_extensions, IOExtensionControl],
        ],
    ],
    [
        Z3kRoutes.climatic_heating_circuits,
        ClimaticHeatingCircuits,
        [[Z3kSecondRoutes.climatic_heating_circuit, ClimaticHeatingCircuitsItem]],
    ],
];
export const z3k_settings_routes = [
    {
        path: `/${Z3kRoutes.main_settings}`,
        element: _jsx(Z3kSettingsDialog, {}),
        children: [
            ...z3k_settings.flatMap(([key, List, sections]) => [
                {
                    path: key,
                    element: _jsx(List, {}),
                    children: [
                        ...sections.flatMap(([section_key, Item, Add]) => {
                            if (Array.isArray(Item)) {
                                return Item.map(([additions_section_key, Item]) => {
                                    return {
                                        path: `${section_key}/${additions_section_key}`,
                                        element: _jsx(Item, {}),
                                    };
                                });
                            }
                            {
                                if (Add !== undefined) {
                                    const [second_children_section, Section] = Add;
                                    return {
                                        path: `${section_key}`,
                                        element: _jsx(Item, {}),
                                        children: [
                                            {
                                                path: `${second_children_section}`,
                                                element: _jsx(Section, {}),
                                            },
                                        ],
                                    };
                                }
                                else {
                                    return {
                                        path: `${section_key}`,
                                        element: _jsx(Item, {}),
                                    };
                                }
                            }
                        }),
                    ],
                },
            ]),
            {
                path: Z3kRoutes.settings,
                element: _jsx(SettingsPage, {}),
            },
            {
                path: Z3kRoutes.search,
                element: _jsx(SearchPage, {}),
            },
            {
                path: Z3kRoutes.access,
                element: _jsx(SharedAccessPage, {}),
            },
            {
                path: Z3kRoutes.z3k_config,
                element: _jsx(ViewConfig, {}),
            },
            {
                path: Z3kRoutes.history_z3k_config,
                element: _jsx(HistoryZ3KConfig, {}),
            },
            {
                path: Z3kRoutes.climatic_configuration,
                element: _jsx(ClimaticConfiguration, {}),
            },
            {
                path: Z3kRoutes.climatic_boilers,
                element: _jsx(ClimaticBoilers, {}),
            },
            {
                path: Z3kRoutes.climatic_digital_sensors,
                element: _jsx(ClimaticDigitalSensors, {}),
            },
            {
                path: Z3kRoutes.climatic_ntc_sensors,
                element: _jsx(ClimaticNtcSensors, {}),
            },
            {
                path: Z3kRoutes.climatic_notifications,
                element: _jsx(ClimaticNotifications, {}),
            },
        ],
    },
];
